import React from 'react'
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Icon,
  Header,
  Image,
  List,
  Menu,
  Segment,
  Input,
  Card,
  Button,
  Step,
  Form,
  Tab,
  Accordion,
  Label,
  Table,
  Checkbox,
} from 'semantic-ui-react'

import bg_0 from '../assets/bg-dashboard-0.png';
import bg_1 from '../assets/bg-dashboard-1.png';
import bg_2 from '../assets/bg-dashboard-2.png';
// import bg_3 from '../assets/bg-dashboard-3.png';
// import bg_4 from '../assets/bg-dashboard-4.png';

const useIntersection = (element, rootMargin) => {
  const [isVisible, setState] = React.useState(false);
  
  // console.log('!!! USE EFFECT', element.current)
      
  React.useEffect(() => {

      const observer = new IntersectionObserver(
          ([entry]) => {
              if (entry.isIntersecting) {
                  setState(entry.isIntersecting);
                  observer.unobserve(element.current);
              } else {
                setState(false);
              }
          },
          {
              rootMargin
          }
      );

      element.current && observer.observe(element.current);

      return () => {
        element.current && observer.unobserve(element.current);
      };
  }, []);

  return isVisible;
};

// class DashboardAnimate extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state= {
      
//     }
//     this.ref =  React.createRef();
//   }
  
//   componentDidMount() {
//     const inViewport = this.props.useIntersection && this.props.useIntersection(this.ref, "200");
//     if (inViewport) {
//         console.log("in viewport:", this.ref.current, inViewport);
//     }
//   }

//   render() {
//     const { screenHeight, screenWidth }= this.props
    
//     return(
//     <div style={{overflow: 'hidden', margin: '6em auto', textAlign: 'center', marginBottom: '2em'}} ref={this.ref}>
//       <div style={{height: '450px', background: '#ffffff url('+ bg +') no-repeat center bottom'}} />
//     </div>
//     )
//   }
// } 

const DashboardAnimate = (props) => {
  const ref = React.useRef();
  // const inViewport = useIntersection(ref, '0px'); // Trigger as soon as the element becomes visible
  const inViewport = useIntersection(ref, '-50%'); // Trigger if 200px is visible from the element
  if (inViewport) {
    console.log('!!! INVIEWPORT', ref.current)
  }
  return (
    <div style={{overflow: 'hidden', margin: '0 auto', textAlign: 'center'}} ref={ref}>
      <div style={{height: '450px', background: '#fafafa url('+ bg_0 +') no-repeat center bottom'}} />
      {inViewport && <div className='experiencefadeout1' style={{visibility: 'hidden', marginTop: '-450px', height: '450px', background: 'url('+ bg_1 +') no-repeat center bottom'}} />}
      {inViewport && <div className='experiencefadeout2' style={{visibility: 'hidden', marginTop: '-450px', height: '450px', background: 'url('+ bg_2 +') no-repeat center bottom'}} />}
      {/* {inViewport && <div className='experiencefadeout3' style={{visibility: 'hidden', marginTop: '-450px', height: '450px', background: 'url('+ bg_3 +') no-repeat center bottom'}} />} */}
      {/* {inViewport && <div className='experiencefadeout4' style={{visibility: 'hidden', marginTop: '-450px', height: '450px', background: 'url('+ bg_4 +') no-repeat center bottom'}} />} */}
    </div>
  );
}

export default DashboardAnimate;
